import { FC } from "preact/compat";
import { Link } from "react-router-dom";
import { me } from "~/core/store";
import useWidget from "../../../Desktop/widgets/Approvals/useWidget";
import { ApprovalLink } from "../../../shared";
import { SingleWidgetProps } from "../interfaces";
import ChevronRightIcon from "@material-design-icons/svg/filled/chevron_right.svg";
import ApprovalsIcon from "@material-design-icons/svg/outlined/task_alt.svg";

const MAX_SHOW_COUNT = 4;

const STUB_FN = () => {};

const Widget: FC<SingleWidgetProps> = ({ className }) => {
    const { loading, approvals } = useWidget({
        id: "approvals-mobile",
        onLink: STUB_FN,
    });
    const show = approvals.value.slice(0, MAX_SHOW_COUNT);

    return (
        <div className={className}>
            <div className="flex justify-between border-b border-gray-200 py-1">
                <div className="flex items-center gap-x-2 text-gray-500 font-bold px-2 py-1">
                    <ApprovalsIcon
                        width="20"
                        height="20"
                        className="fill-current"
                    />
                    <span>Approvals</span>
                </div>
                <Link
                    to={me("admin/approval")}
                    className="flex items-center gap-x-1 text-gray-500 font-bold px-2 py-1"
                >
                    <span>View all</span>
                    <ChevronRightIcon
                        width="20"
                        height="20"
                        className="fill-current"
                    />
                </Link>
            </div>
            <div className="p-4 flex flex-col gap-y-2">
                {!loading.value && approvals.value.length === 0 && (
                    <>
                        <div className="text-center">
                            No active approvals yet.
                        </div>
                        <Link
                            to={me("admin/approval")}
                            className="text-sky-600 underline text-center"
                        >
                            View all
                        </Link>
                    </>
                )}
                {show.map((approval) => (
                    <ApprovalLink key={approval.id} approval={approval} />
                ))}
            </div>
        </div>
    );
};

export default Widget;
